import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/notFound.css';

export const NotFound = () => {
  return (
    <div className="notFoundContainer">
      <div className="content">
        <h1>Sorry, the page you are looking for isn't here!</h1>
        <Link to="/">
          <button ariaLabel="Go Back" className="retry">
            Go Back
          </button>
        </Link>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/NotFound.js